import { lazy } from 'react';

const Merchants = lazy(() => import('./AdminMerchantsPage'));

const AdminMerchantsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: 'admin/merchant',
      element: <Merchants />,
    },
  ],
};

export default AdminMerchantsConfig;
